import React from 'react'

function About() {
  return (
    <div className='p-5 text-center'>
      <h1 className='text-6xl font-bold mb-5'>ABOUT</h1>
      <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Autem repellendus fuga nesciunt quisquam esse provident quam officiis et vitae possimus cupiditate illo sequi odit earum natus eius magni, aperiam alias perferendis in deleniti voluptatum ipsa! Velit, perspiciatis laborum beatae voluptatum quae iure aliquid consectetur soluta </p>
      <br/>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis, aliquam. Eaque accusantium hic esse, delectus quidem, non sed consectetur nesciunt animi nemo mollitia deleniti ullam a atque, eveniet necessitatibus odit.</p>
    </div>
  )
}

export default About
